export default class MetaService {
    handleMeta(response) {
        if (response.data.data) {
            if (response.data.meta && response.data.meta.features) {
                window.localStorage.setItem('kgr_features', response.data.meta.features);
            } else {
                window.localStorage.setItem('kgr_features', null);
            }
            if (response.data.meta && response.data.meta.modules) {
                window.localStorage.setItem('kgr_modules', response.data.meta.modules);
            } else {
                window.localStorage.setItem('kgr_modules', null);
            }
        }
    }
}
